import { render } from "./App.vue?vue&type=template&id=d1163a3e"
import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Mask/Tiles/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d1163a3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d1163a3e', __exports__)) {
    api.reload('d1163a3e', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=d1163a3e", () => {
    api.rerender('d1163a3e', render)
  })

}


export default __exports__